import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    isArchiving?: boolean;
    onClose: () => void;
    onArchive: () => void;
};

const ArchiveCustomerModal = ({ open, onClose, onArchive, isArchiving }: Props) => {
    return (
        <ConfirmationModal
            open={open}
            width={420}
            icon={<ContainerOutlined />}
            title="Archive Customer?"
            confirmButtonText="Archive"
            confirmationButtonLoading={isArchiving}
            onConfirm={onArchive}
            onCancel={onClose}
            content={<Typography.Text>The customer will be added to the archive.</Typography.Text>}
        />
    );
};

export default ArchiveCustomerModal;
